import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import { StatusChangeType } from '@recruitee/offers-data';
import type { OfferItem } from '@recruitee/offers-types';
import { OfferKind, OfferStatus } from '@recruitee/offers-types';
import {
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-actions-dropdown',
  templateUrl: './actions-dropdown.component.html',
  styleUrls: ['./actions-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconButtonComponent,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    RouterLink,
    IconComponent,
    TranslatePipe,
  ],
})
export class ActionsDropdownComponent {
  @Input() public offer: OfferItem;
  @Input() public type: 'table' | 'list';
  @Input() public canManageJobs = false;
  @Input() public canViewAcquisition = false;

  @Output() public action = new EventEmitter<StatusChangeType>();
  @Output() public trackPreview = new EventEmitter<void>();

  public ActionType: typeof StatusChangeType = StatusChangeType;
  public OfferKind: typeof OfferKind = OfferKind;
  public OfferStatus: typeof OfferStatus = OfferStatus;
  public DropdownWidth = DropdownWidth;
}
